import { render } from "./ObraList.vue?vue&type=template&id=07129ec0"
import script from "./ObraList.vue?vue&type=script&lang=js"
export * from "./ObraList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__